<template>
  <div v-if="isTargetVersion">
    <div v-if="isReadyToDraw">
      <TheNotificationsArea :notifications="notifications" />

      <TemplateMfittIndex />
    </div>

    <!-- index画面の描画ローディング -->
    <ItemDialogForIndexPage v-else />
  </div>
</template>

<script>
import TemplateMfittIndex from "@/views/Templates/MFITT/TemplateMfittIndex";

import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";

// API
import API from "@/API";

import nativeHandlerService from "@/services/nativeHandler";
import { isAppVersionGreater } from "@/lib/compareVersion";

export default {
  name: "MfittIndex",
  components: {
    TemplateMfittIndex,
  },
  setup() {
    const store = useStore();

    const appVersion = computed(() => store.getters["common/appVersion"]);
    const device = computed(() => store.getters["common/device"]);
    const isTargetVersion = ref(false);

    const isReadyToDraw = ref(false);

    const notifications = ref(null);

    // 対象のバージョンかどうか確認
    const checkVersion = () => {
      let bool = false;
      switch (device.value) {
        case "IOS":
          bool = isAppVersionGreater(appVersion.value, "2.5.1");
          break;
        case "ANDROID":
          bool = isAppVersionGreater(appVersion.value, "2.5.2");
          break;
        default:
          bool = true;
          break;
      }
      isTargetVersion.value = bool;
    };

    onMounted(async () => {
      try {
        // index上部に表示する通知を取得
        notifications.value = (await API.getNotifications()).express_tickets;
      } catch (err) {
        console.log("Error in getNotifications: ", err);
      }

      try {
        nativeHandlerService.ncAppVersion();

        // isPast:false
        await Promise.all([
          // isPast:false
          API.getMyLimitedExpressTickets(false),
          // Myクーポン取得(isNotRecall: true)
          API.getMyCoupons(true),
        ]);
        isReadyToDraw.value = true;
      } catch (_) {
        // 未ログイン時は特急券取得でエラーとなる
        // 一覧を空白で表示する
        isReadyToDraw.value = true;
      }
    });

    watchEffect(() => {
      if (appVersion.value != null && appVersion.value != undefined) {
        checkVersion();
      }
    });

    return {
      isReadyToDraw,
      isTargetVersion,
      notifications,
    };
  },
};
</script>
